import Index from 'modules/help/detail';

export default Index;
